module.exports = __webpack_public_path__ + "static/img/huaishuImg2.43cf21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/huaishuImg2.png
// module id = ILYR
// module chunks = 0